<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-dynamic" :inline="true">
            <el-form-item label="批量价格" prop="BatchPrice" class="BatchPrice">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchPrice" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('price')">批量设置价格</el-button>
            </el-form-item>
            <el-form-item label="批量库存" prop="BatchInventory">
                <el-input :disabled="stateDisabled" v-model="ruleForm.BatchInventory" size="small" class="input1"></el-input>
                <el-button :disabled="stateDisabled" type="primary" size="small" @click="batchSetting('stock')">批量设置库存</el-button>
            </el-form-item>
        </el-form>

        <div v-for="(item, index) of skuList" :key="index" class="gauge">
            <div class="left">{{ item.skuNameKv.kvName }}</div>

            <div class="valueKv">
                <div class="kvName" v-for="element of item.valueKvList">
                    <!-- <i class="el-icon-close close" @click="closekvName(element.kvName)"></i> -->
                    {{ element.kvName }}
                </div>
                <div>
                    <el-button size="small" type="primary" @click="handleAdd(item)">新增规格值</el-button>
                </div>
            </div>
        </div>

        <el-table size="small" :data="tableData" max-height="450px" border style="width: 100%" v-if="tableData.length != 0">
            <el-table-column
                v-for="(item, index) of skuList"
                :key="index"
                align="center"
                :prop="'kvName' + index"
                :label="item.skuNameKv.kvName"
            >
                <template slot-scope="{ row }">
                    <el-select
                        v-model="row['kvName' + index]"
                        size="small"
                        placeholder="请选择"
                        style="width: 120px"
                        :disabled="stateDisabled"
                        @change="onSpecChange(row)"
                    >
                        <el-option
                            v-for="opt in item.valueKvList"
                            :key="opt.kvId"
                            :label="opt.kvName"
                            :value="opt.kvName"
                        />
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column align="center" label="价格">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.price"
                        placeholder="请输入价格"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="供货价">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        type="number"
                        :disabled="stateDisabled"
                        v-model="scope.row.supplyPrice"
                        placeholder="请输入供货价"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="利润率">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        type="number"
                        :disabled="true"
                        :value="(scope.row.supplyPrice && scope.row.price) ? ((scope.row.price - scope.row.supplyPrice) / scope.row.price * 100).toFixed(2) : ''"
                        placeholder="利润率"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="数字资产">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        type="number"
                        :disabled="stateDisabled"
                        v-model="scope.row.vbaoEnterRatio"
                        placeholder="请输入数字资产"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="库存">
                <template slot-scope="scope"
                    ><el-input
                        size="small"
                        style="width: 60%"
                        :disabled="stateDisabled"
                        v-model="scope.row.stock"
                        placeholder="请输入库存"
                    ></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="图片">
                <template slot-scope="scope">
                    <el-upload
                        class="avatar-uploader"
                        style="width: 80px; height: 80px; text-align: center"
                        :data="scope.row"
                        :disabled="stateDisabled"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadSkuPicture"
                    >
                        <img v-if="scope.row.pic" :src="scope.row.pic" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
		<skuEditDialog
			v-if="dialogVisible"
			:shopProduct="shopProduct"
			:visible="dialogVisible"
			:skuItem="skuItem"
			@close="skuEditDialogClose"
		></skuEditDialog>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun, upload, postJson } from '@/utils/request.js';
import skuEditDialog from './skuEditDialog.vue';

export default {
    props: {
        shopProduct: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            ruleForm: {
                BatchPrice: '',
                BatchInventory: '',
                Specifications: ''
            },
            Specifications: '',
            rules: {},
            skuList: [],
            skuValueList: [],
            brand: {},
            tableData: [],
            arrData: [],
            stateDisabled: false,
            dialogVisible: false,
            skuItem: null
        };
    },

    created() {
        eventBus.$on('skuList', (data, value, state) => {
            console.log('skuList的data',data);
            console.log('skuList的value',value);
            this.skuList = data;
            this.skuValueList = value;
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }

            this.combination();
            console.log(data, value);
        });
    },
    beforeDestroy() {
        eventBus.$off('skuList');
    },
    methods: {
        onSpecChange(row) {
            const ids = [];
            for (let i = 0; i < this.skuList.length; i++) {
                const kvName = row['kvName' + i];
                const found = this.skuList[i].valueKvList.find((v) => v.kvName === kvName);
                if (found) ids.push(found.kvId);
            }
            row.skuKvIds = ids.length ? this.ascending(ids.join(',')) : '';
            const matched = this.findSkuValueMatch(row.skuKvIds);
            if (matched) {
                row.id = matched.id;
                row.pic = matched.pic;
                row.price = matched.price;
                row.stock = matched.stock;
                row.supplyPrice = matched.supplyPrice;
                row.vbaoEnterRatio = matched.vbaoEnterRatio;
                return;
            }
            row.id = null;
            row.pic = '';
            row.price = '';
            row.stock = '';
            row.supplyPrice = '';
            row.vbaoEnterRatio = '';
        },

        closekvName(element) {
            console.log(element);
            loop: for (let item of this.skuList) {
                for (let i = 0; i < item.valueKv.length; i++) {
                    if (item.valueKv[i].kvName == element) {
                        item.valueKv.splice(i, 1);
                        this.combination();
                        break loop;
                    }
                }
            }
            for (let i = 0; i < this.skuList.length; i++) {
                if (this.skuList[i].valueKv == 0) {
                    console.log(this.skuList[i]);
                    eventBus.$emit('speckvName', this.skuList[i].kvName);
                    this.skuList.splice(i, 1);
                    if (this.skuList.length != 0) {
                        this.combination();
                    }
                    break;
                }
            }
            console.log(this.skuList);
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        combination() {
            let combine = function (skuList) {
                // console.log(skuList);
                let res = [];
                let recursion = function (chunkIndex, prev) {
                    let skuValueList = skuList[chunkIndex].valueKvList;
                    // console.log(skuValueList);

                    let isLast = chunkIndex === skuList.length - 1;
                    for (let val of skuValueList) {
                        let temporary = prev.concat(val);
                        if (isLast) {
                            // 如果已经处理到数组的最后一项了 则把拼接的结果放入返回值中
                            res.push(temporary);
                        } else {
                            recursion(chunkIndex + 1, temporary);
                        }
                    }
                };
                // 从属性数组下标为 0 开始处理  // 并且此时的 prev 是个空数组
                recursion(0, []);
                return res;
            };
            let arr = combine(this.skuList);
            console.log(arr);
            this.tableData = [];
            let j = 0;
            for (let item of arr) {
                let i = 0;
                let obj = {
                    skuKvIds: ''
                };

                for (let element of item) {
                    let key1 = 'kvName' + i;
                    let key2 = 'price';
                    let key3 = 'stock';
                    let key4 = 'pic';
                    let key5 = 'id';
                    i++;
                    obj[key1] = element.kvName;
                    obj[key2] = '';
                    obj[key3] = '';
                    obj[key4] = '';
                    obj[key5] = j++;
                    obj.skuKvIds += element.kvId + ',';
                }
                if (obj.skuKvIds.length > 0) {
                    obj.skuKvIds = obj.skuKvIds.substr(0, obj.skuKvIds.length - 1);
                }
                obj.skuKvIds = this.ascending(obj.skuKvIds);

                obj.supplyPrice = '';
                obj.vbaoEnterRatio = '';

                // console.log(obj);
                this.tableData.push(obj);
                // break;
            }
            this.format();

            console.log(this.tableData);
        },
        format() {
            for (let item of this.tableData) {
                const matched = this.findSkuValueMatch(item.skuKvIds);
                if (matched) {
                    item.id = matched.id;
                    item.pic = matched.pic;
                    item.price = matched.price;
                    item.stock = matched.stock;
                    item.supplyPrice = matched.supplyPrice;
                    item.vbaoEnterRatio = matched.vbaoEnterRatio;
                }
            }
        },
        /**
         * 在 skuValueList 中查找与给定 rowKvIds 匹配的项
         * 优先精确匹配，其次子集匹配（兼容后端返回单维度 skuKvIds 的情况）
         */
        findSkuValueMatch(rowKvIds) {
            if (!rowKvIds) return null;
            const rowIds = rowKvIds.split(',').map(Number);
            // 第一轮：精确匹配（完整组合 key）
            for (let element of this.skuValueList) {
                if (rowKvIds === element.skuKvIds) {
                    return element;
                }
            }
            // 第二轮：子集匹配（兼容后端仅返回单维度 skuKvIds 的情况）
            // 优先匹配 kvId 数量更多的项（更精确）
            let bestMatch = null;
            let bestMatchLen = 0;
            for (let element of this.skuValueList) {
                const elementIds = element.skuKvIds.split(',').map(Number);
                if (elementIds.length > bestMatchLen && elementIds.every(id => rowIds.includes(id))) {
                    bestMatch = element;
                    bestMatchLen = elementIds.length;
                }
            }
            return bestMatch;
        },
        // 升序排列
        ascending(value) {
            var array = new Array();
            array = value.split(',');
            // for (var element in array) {
            //     array[element] = parseInt(array[element]);
            // }
            array = array.sort(function (a, b) {
                return a - b;
            });
            return array.toString();
        },

        // 上传图片
        uploadSkuPicture(params) {
            console.log(params);
            const file = params.file;
            let product = params.data;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    for (let item of this.tableData) {
                        if (item.id == product.id) {
                            item.pic = res.url;
                        }
                    }

                    console.log(this.tableData);
                }
            });
        },
        // 批量设置
        batchSetting(value) {
            if (this.tableData.length != 0) {
                for (let item of this.tableData) {
                    if (value == 'price') {
                        if (this.ruleForm.BatchPrice == '') {
                            this.$message({
                                message: '价格不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.price = this.ruleForm.BatchPrice;
                    }
                    if (value == 'stock') {
                        if (this.ruleForm.BatchInventory == '') {
                            this.$message({
                                message: '库存不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.stock = this.ruleForm.BatchInventory;
                    }
                }
                if (value == 'price') {
                    this.ruleForm.BatchPrice = '';
                }
                if (value == 'stock') {
                    this.ruleForm.BatchInventory = '';
                }
            }
        },
        handleDel(item) {
            postJson(`/shop/product/deleteSkuValue?productId=${this.shopProduct.id}&skuValueId=${item.id}`,{}).then(res=>{
                if (res.success) {
                    this.tableData = this.tableData.filter((item1) => {
                        return item.id !== item1.id
                    })
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'warning'
                    });
                }
            })
        },
        handleAdd(val) {
            this.dialogVisible = true
            this.skuItem = val
        },
        skuEditDialogClose(val) {
            if (val) {
                get(`/shop/product/get`, { id: this.shopProduct.id }).then((res) => {
                    if (res.success && res.code == 200) {
                        let { skuList, skuValueList } = res.shopProduct;
                        this.skuList = skuList;
                        this.skuValueList = skuValueList;
                        this.combination();
                    }
                })
            }
            this.dialogVisible = false
        }
    },
    components:{
        skuEditDialog
    }
};
</script>
<style lang="scss" scoped>
.input1 {
    margin-right: 15px;
}
.Specifications {
    padding-left: 100px;
    margin-bottom: 22px;
}
.input2 {
    width: 50%;
    margin: 10px 0;
}
::v-deep .el-input {
    width: 100px;
}
::v-deep .el-select {
    width: 100px;
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}

.gauge {
    color: #606266;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    .left {
        line-height: 32px;
        width: 58px;
        margin-right: 12px;
        text-align: right;
    }
}
.valueKv {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .kvName {
        padding: 0 10px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        margin: 0 10px 10px 0;
        position: relative;
    }
    .close {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background-color: #409eff;
        color: #fff;
        border-radius: 100%;
    }
}
.el-table {
    margin-bottom: 20px;
}

::v-deep .el-upload {
    width: 80px !important;
    height: 80px !important;
    text-align: center;
}
.avatar-uploader {
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
}
</style>
